import React from 'react'
import AltNav from '../components/AltNav.js';

const BetweenBands = () => {
    return (
        <div>
            <AltNav />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

            <div className='work-page-main'>
                <div className='blue-glow projects-header'>
                    <div className='gb-inner gb-inner-img' style={{ backgroundImage: `url('portfolio-images/between-bands.jpg')` }}>
                        <div class="glow-wrapper">
                            <span class="glow-text">BETWEEN BANDS</span>
                            <span class="stroke-text">BETWEEN BANDS</span>
                        </div>

                        <h2>EDUTAINMENT APP</h2>
                    </div>
                </div>


                <br />
                <br />

                <div className='overview'>
                    <div className='ov1'>
                        <h2>Overview</h2>

                        <p>Entertainment App I built for Scholatship Auditions as an intern.</p>

                        <ul>
                            <li>Built with React</li>
                            <li>We refer to it as an Edutainment app, Education + Entertainment. Designed for audience members</li>
                            <li>This came before Between Choirs</li>
                            <li>It features the same games and activities as Between Choirs, just marching band themed</li>
                            <li>This Includes a trivia quiz, tic tac toe, crossword puzzle, coloring book, and scavenger hunt.</li>
                            <li>Also contains articles about marching band</li>
                            <li>Feel free to play through them</li>
                        </ul>
                        <a href='https://betweenchoirs.com/' target='_blank'>
                            <button className='glow-box-btn ovbtn'>
                                View Site
                            </button>
                        </a>

                    </div>
                    <div className='ov2'>
                        <div className='pink-glow'>
                            <div className='pg-inner'>
                                <img src='portfolio-images/bb1.jpg' alt='Eventure Desktop View' />
                            </div>

                        </div>

                    </div>
                </div>
                <br />
                <br />




                <div className='pink-glow'>
                    <div className='pg-inner project-summary'>
                        <h3 className='summary'>Summary</h3>
                        <p>Between Bands is an interactive web platform built to entertain and engage marching band members, families, and fans during long competition days. Designed for use between performances, the site features games, voting polls, schedules, and announcements to keep users connected and involved throughout the event. With a fun, mobile-friendly interface and bold, energetic visuals, Between Bands enhances the downtime experience at band competitions and showcases my skills in UX design, front-end development, and real-time content delivery.</p>
                    </div>
                </div>

                <br />
                <br />







            </div>

        </div>
    )
}

export default BetweenBands